import './Banner.css'

export const Banner = () => {
    return (
        <header className="banner">
            <img src="/imagem/banner.png" alt="banner" />
        </header>
    )
}